module.exports = __webpack_public_path__ + "static/img/welcome-to-bright-city.7a2c05b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/characters/welcome-to-bright-city.svg
// module id = CJN4
// module chunks = 1